// @owners { team: patients }
import { type SurveyResponse } from '@alto/scriptdash/alto/surveys/types/v1/survey_response';
import { type QueryClient } from '@tanstack/react-query';
import { queries } from '~shared/queries/query-keys';
import { Sentry } from '~shared/sentry';

/**
 * Imperatively fetch the pending "rate shipment" survey via React Query — for the non-React call
 * sites (native app-open middleware, web post-auth hook) that can't use the useGetPendingRateShipment
 * hook. Returns the pending survey, or null if there is none / on error (so the modal stays hidden).
 */
export const fetchPendingRateShipment = async (queryClient: QueryClient): Promise<SurveyResponse | null> => {
  try {
    return (await queryClient.fetchQuery(queries.rateShipment.pending)) ?? null;
  } catch (error) {
    // Capture so a 401/5xx/timeout on the survey check stays visible in production (the old thunk
    // surfaced these via dispatched failure actions / Sentry redux breadcrumbs).
    Sentry.captureException(error instanceof Error ? error : new Error('fetchPendingRateShipment failed'));
    return null;
  }
};
